var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", { attrs: { method: "post" } }, [
    _c("div", { staticClass: "col-md-11 p-h-xs" }, [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.notification_content,
                expression: "notification_content",
              },
            ],
            staticClass: "col-md-12",
            attrs: {
              type: "text",
              name: "notification_content",
              placeholder: "Content goes here.. ",
            },
            domProps: { value: _vm.notification_content },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.notification_content = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "ladda-button",
            {
              staticClass: "btn btn-sm btn-success col-md-2",
              attrs: { type: "submit", click: _vm.saveContents },
            },
            [_vm._v("\n        Save\n      ")]
          ),
          _vm._v(" "),
          _c(
            "ladda-button",
            {
              staticClass: "btn btn-sm btn-danger col-md-2",
              attrs: { type: "submit", click: _vm.resetContents },
            },
            [_vm._v("\n        Reset\n      ")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }